.theme {
  --asset-accent: #1d4ed8;
  --asset-dark: #1e40af;
  --asset-deep: #172554;
  --asset-soft: #eff6ff;
  --asset-pale: #dbeafe;
  --asset-border: #bfdbfe;
  --asset-border-strong: #93c5fd;
  --asset-shadow-rgb: 29 78 216;
}
